// extracted by mini-css-extract-plugin
module.exports = {"icon":"BtnFav_icon__2_7pQ","favoriteIcon":"BtnFav_favoriteIcon__2UJiE"};